import axios from 'Src/helpers/api/axiosInstance';
import { SuperAdminSession } from 'Src/models/superadmin/session';
import { clearSuperAdminSession, setSuperAdminSession } from 'Src/helpers/session/superadminSession';

export function loginSuperAdmin(email: string, password: string): Promise<SuperAdminSession> {
  return axios.post(`${window.apiBase}/superadmin/login`, { email, password }).then(response => {
    const session = response.data;
    setSuperAdminSession(session);
    return session;
  });
}

export function logoutSuperAdmin(): void {
  clearSuperAdminSession();
}
